import React from 'react';
import { Button } from 'rsuite';
export default class ButtonTip extends React.Component {
    constructor(props) {
        super(props);
        this.opentips = this.opentips.bind(this);

    }

    opentips() {
        this.props.updateTips(this.props.ind);
    }

    

    render() {
        
        //Estilos hide/show ajuda
        var mostra = {
            boxShadow: 'none',
            top: '5px'
        };

        var hide = {
            boxShadow: "0 7px 0 #202020",
            top: '0px'
        };

        //Estilo de acerto da palavra
        var nada

        var acertou = {
            boxShadow: 'none',
            top: '7px',
            color:'#0A4136',
            background: '#FFD286',
            borderColor:'#0A4136',
            borderWidth:'2px',
        };

        return (
            <Button className='sizeButton borColor3 Color4 button1 buttonIncial' 
            style={Object.assign({}, this.props.tipsOpen[this.props.ind] ? mostra : hide, this.props.palavras[this.props.ind] ? acertou : nada) }
            
             onClick={this.opentips} >{this.props.ind+1} 
             </Button>
                    
        );
    }
}
